import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PageNumbers, ReportState } from 'src/app/model/Enums';
import { Report } from 'src/app/model/report';
import {ReportProvider, UserProvider} from 'src/app/providers';
import {ReportService, ToasterService, UserService} from 'src/app/services';

@Component({
  selector: 'report-side-menu',
  templateUrl: './report-side-menu.component.html',
  styleUrls: ['./report-side-menu.component.scss']
})
export class ReportSideMenuComponent implements OnInit, OnDestroy {

  @Input() stageNo: number = 0;
  @Output() pageChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  public currentReport: Report;
  private reportSub: Subscription;

  pageNumberEnum = PageNumbers;

  reportStateEnum = ReportState;
  resourcesList: any[] = [];

  PROMO_CODE: string;

  constructor(
    public reportService: ReportService,
    private router: Router,
    public userService: UserService,
    private reportProvider: ReportProvider,
    private userProvider: UserProvider,
    private toastr: ToasterService,
  ) { }

  ngOnInit(): void {
    this.reportSub = this.reportService.report$.subscribe(currentReport => {
      this.currentReport = currentReport;
    });
  }

  ngOnDestroy(): void {
    if (this.reportSub)
      this.reportSub.unsubscribe();
  }

  gotoPage(pageLink: string) {
    this.pageChanged.emit(true);
    this.router.navigateByUrl(`/report/${this.currentReport.ID}/${pageLink}`);
  }

  getResourcesList() {
    this.reportProvider.getResources().subscribe(resp => {
    })
  }

  /** to check promo code */
  applyPromoCode(): void {
    this.userProvider.addPromoForBroker(this.PROMO_CODE).subscribe((resp) => {
      if (resp.success) {
        this.userService.setUserPremium(true);
        this.reportService.updateConclusionPage.emit(true);
        this.toastr.success('Promo Code has been accepted, your report has been unlocked.');
      } else {
        this.toastr.error(resp.error.txt);
      }
      this.PROMO_CODE = null;
    }, err => {
      // Error Handling
    });
  }

}
